import { z } from 'zod'

export const paramsSchema = z.object({
  emailAddress: z.string(),
  googleId: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>
